import translations from "./ShipmentTypesTranslations.json";
import { translate } from "@flow-frontend-npm/common";

/**
 * Simplified call off translate
 * @param {string} key
 * @return {string} translation
 */
const t = (key) => translate(translations, key);

const shipmentTypes = {
    IN: {
        value: "WE",
        label: t("shipmentType.in")
    },
    OUT: {
        value: "WA",
        label: t("shipmentType.out")
    },
    BOTH: {
        value: "WE/WA",
        label: t("shipmentType.both")
    },
    NONE: {
        value: "WL",
        label: t("shipmentType.none")
    }
};

export default shipmentTypes;
